import { cx } from '@linaria/core';
import { mdiYoutubeSubscription } from '@mdi/js';
import Icon from '@mdi/react';
import { IconProps } from '.';
import "./MfcShareFeed.linaria.module.css!=!./MfcShareFeed?./MfcShareFeed.linaria.module.css?css=H4sIAAAAAAAAA9NLLMmNz82OzzDKzc0yqy7IL84syczPsypKzUksySxLta7l0gMpKcmON8wzTMzLtqwuyS+w0jUsqLCu5QIA0VYqGT4AAAA="
const iconStyles = "atm_mk_h2mmj6 atm_tk_1n1ank9";
const MfcShareFeed = (props: IconProps) => {
  const {
    filled,
    color,
    size = 1,
    title,
    className,
    ...other
  } = props;
  return <Icon data-testid="IconButton__MfcShareFeed" path={mdiYoutubeSubscription} title={title} size={size} color={color} className={cx(iconStyles, className)} {...other} />;
};
export default MfcShareFeed;